import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import Text from 'components/common/Text'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
  margin-top: 10px;
  padding-bottom: 10px;
`
const NameContainer = styled.div`
  display: flex;
  width: 150px;
  height: 30px;
  align-items: center;
  justify-content: space-between;
`
const ResetTextContainer = styled.div`
  margin-left: 30px;
  cursor: pointer;
`
const SizesContainer = styled.div`
  width: 300px;
  display: flex;
  justify-content: space-between;
`

const SizeButton = styled.div`
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30%;
  display: inline-flex;
  font-size: 16px;
  border-radius: 4px;
  background-color: #eaf7ff;
  border: solid 1px #3899EC;
  cursor: pointer;
`

class SPTextSize extends Component {

  constructor (props) {
    super(props)
    this.state = {
      value: ''
    }
    this.debouncedOnChange = _.throttle(props.onChange, 300)
  }

  onChange = (data) => {
    // console.log('onChange', data)
    const v = data
    if (v !== this.state.value) {
      this.setState({
        value: v
      })
      this.debouncedOnChange({'font-size': v})
    }
  }

  onReset = () => {
    this.props.onChange({})
    this.setState({
      value: ''
    })
  }

  renderButtons = () => {
    const options = [
      {
        type: '100%',
        value: 1
      },
      {
        type: '125%',
        value: 1.25
      },
      {
        type: '150%',
        value: 1.5
      }
    ]

    return options.map((option, index) => {
      return (
        <SizeButton
          key={index}
          onClick={() => {
            const value = `${option.value}em`
            this.onChange(value)
          }}
        >
          {option.type}
        </SizeButton>
      )
    })
  }

  render () {
    const { title } = this.props
    return (
      <Container>
        <NameContainer>
          <Text size='medium'>{title}</Text>
        </NameContainer>

        <SizesContainer>
          { this.renderButtons() }
        </SizesContainer>

        <ResetTextContainer
          onClick={this.onReset}
        >
          <Text size='medium'>RESET</Text>
        </ResetTextContainer>
      </Container>
    )
  }
}

SPTextSize.defaultProps = {
  currentValue: 0,
  onChange: () => null,
  title: '',
}

SPTextSize.propTypes = {
  // currentValue: PropTypes.number,
  onChange: PropTypes.func,
  title: PropTypes.string,
}

export default SPTextSize



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPTextSize.js